/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_Index_Searchplaceholder1Inputs */

const id_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari changelog...`)
};

const ms_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari changelog...`)
};

const da_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg i ændringslog...`)
};

const de_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsprotokolle durchsuchen...`)
};

const en_us2_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search changelogs...`)
};

const es_es2_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar registros de cambios...`)
};

const es_mx2_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar registros de cambios...`)
};

const fil_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap ng talaan ng pagbabago...`)
};

const fr_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher dans les journaux…`)
};

const it_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca nei registri modifiche...`)
};

const hu_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változásnaplók keresése...`)
};

const nl_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingslogboeken doorzoeken...`)
};

const no_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk i endringslogger...`)
};

const pl_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj w dziennikach zmian...`)
};

const pt_br2_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar registros de alterações...`)
};

const pt_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar registos de alterações...`)
};

const ro_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caută în jurnalele de modificări...`)
};

const fi_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae muutoslokeja...`)
};

const sv_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök i ändringsloggar...`)
};

const vi_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm nhật ký thay đổi...`)
};

const tr_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik günlüklerini ara...`)
};

const cs_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat v seznamech změn...`)
};

const bg_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене на дневници на промените...`)
};

const ru_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск в журналах изменений...`)
};

const uk_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук у журналі змін...`)
};

const ar_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البحث في سجلات التغييرات...`)
};

const hi_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलाव लॉग खोजें...`)
};

const th_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาบันทึกการเปลี่ยนแปลง...`)
};

const ja_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新履歴を検索...`)
};

const zh_cn2_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索更新日志...`)
};

const zh_hant1_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋更新日誌...`)
};

const ko_changelog_index_searchplaceholder1 = /** @type {(inputs: Changelog_Index_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 내역 검색...`)
};

/**
* | output |
* | --- |
* | "Search changelogs..." |
*
* @param {Changelog_Index_Searchplaceholder1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const changelog_index_searchplaceholder1 = /** @type {((inputs?: Changelog_Index_Searchplaceholder1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_Index_Searchplaceholder1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_changelog_index_searchplaceholder1(inputs)
	if (locale === "ms") return ms_changelog_index_searchplaceholder1(inputs)
	if (locale === "da") return da_changelog_index_searchplaceholder1(inputs)
	if (locale === "de") return de_changelog_index_searchplaceholder1(inputs)
	if (locale === "en-US") return en_us2_changelog_index_searchplaceholder1(inputs)
	if (locale === "es-ES") return es_es2_changelog_index_searchplaceholder1(inputs)
	if (locale === "es-MX") return es_mx2_changelog_index_searchplaceholder1(inputs)
	if (locale === "fil") return fil_changelog_index_searchplaceholder1(inputs)
	if (locale === "fr") return fr_changelog_index_searchplaceholder1(inputs)
	if (locale === "it") return it_changelog_index_searchplaceholder1(inputs)
	if (locale === "hu") return hu_changelog_index_searchplaceholder1(inputs)
	if (locale === "nl") return nl_changelog_index_searchplaceholder1(inputs)
	if (locale === "no") return no_changelog_index_searchplaceholder1(inputs)
	if (locale === "pl") return pl_changelog_index_searchplaceholder1(inputs)
	if (locale === "pt-BR") return pt_br2_changelog_index_searchplaceholder1(inputs)
	if (locale === "pt") return pt_changelog_index_searchplaceholder1(inputs)
	if (locale === "ro") return ro_changelog_index_searchplaceholder1(inputs)
	if (locale === "fi") return fi_changelog_index_searchplaceholder1(inputs)
	if (locale === "sv") return sv_changelog_index_searchplaceholder1(inputs)
	if (locale === "vi") return vi_changelog_index_searchplaceholder1(inputs)
	if (locale === "tr") return tr_changelog_index_searchplaceholder1(inputs)
	if (locale === "cs") return cs_changelog_index_searchplaceholder1(inputs)
	if (locale === "bg") return bg_changelog_index_searchplaceholder1(inputs)
	if (locale === "ru") return ru_changelog_index_searchplaceholder1(inputs)
	if (locale === "uk") return uk_changelog_index_searchplaceholder1(inputs)
	if (locale === "ar") return ar_changelog_index_searchplaceholder1(inputs)
	if (locale === "hi") return hi_changelog_index_searchplaceholder1(inputs)
	if (locale === "th") return th_changelog_index_searchplaceholder1(inputs)
	if (locale === "ja") return ja_changelog_index_searchplaceholder1(inputs)
	if (locale === "zh-CN") return zh_cn2_changelog_index_searchplaceholder1(inputs)
	if (locale === "zh-Hant") return zh_hant1_changelog_index_searchplaceholder1(inputs)
	return ko_changelog_index_searchplaceholder1(inputs)
});
export { changelog_index_searchplaceholder1 as "changelog.index.searchPlaceholder" }